// extracted by mini-css-extract-plugin
export default {"card":"SWAsy6","recommendedCard":"E_DxMu","planName":"Prykt2","planDescription":"BMGysD"};